import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import useHttp from "../../../hooks/use-http";
import { settingAction } from "../../../store/setting-store";
import { endPoints } from "../../../config/end-points";
import * as serviceWorker from "../../../helpers/push/serviceWorker";
import { subscribeUser } from "../../../helpers/push/subscription";

const WebPush = () => {
  const { sendRequest } = useHttp();
  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();

  const is_loaded_push_notification = useSelector(
    (state) => state.settings.is_loaded_push_notification
  );

  const push_notification = useSelector(
    (state) => state.settings.push_notification
  );

  //   load or register the service worker at first time
  useEffect(() => {
    serviceWorker.register();
  });

  useEffect(() => {
    if (!is_loaded_push_notification) {
      sendRequest(
        {
          url: endPoints.webpushStatus,
          body: "",
          method: "GET",
        },
        (response) => {
          // console.log(response.status);
          if (response.status === 200) {
            // if (response.count >= 1) {
            dispatch(
              settingAction.setPusNotification({
                push_notification: response.count >= 1 ? true : false,
                is_loaded_push_notification: true,
              })
            );
            // }
          }
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_loaded_push_notification]);

  //   Enable or diable the push notification
  const handlePushNotification = () => {
    if (!push_notification) {
      subscribeUser(token);
      dispatch(
        settingAction.setPusNotification({
          push_notification: true,
          is_loaded_push_notification: true,
        })
      );
    } else {
      sendRequest(
        {
          url: endPoints.unsubscribe,
          body: "",
          method: "GET",
        },
        (response) => {
          // console.log(response.status);
          if (response.status === 200) {
            dispatch(
              settingAction.setPusNotification({
                push_notification: false,
                is_loaded_push_notification: true,
              })
            );
          }
        }
      );
    }
  };

  return (
    <>
      <div className="col-md-12 mb-4">
        <div className="bx_a">
          <h5 className="mb-4 pb-3 small_title d-flex">
            Enable Push Notification
          </h5>
          <button
            onClick={handlePushNotification}
            className={`btn btn-${push_notification ? "danger" : "success"}`}
          >
            {push_notification ? "Disable" : "Enable"}
          </button>
        </div>
      </div>
    </>
  );
};

export default WebPush;
